import React from 'react';
import { Button } from './ui/button';
import { contactData } from '../data/mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white py-16 relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48cGF0dGVybiBpZD0iZ3JpZCIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIj48cGF0aCBkPSJNIDQwIDAgTCAwIDAgMCA0MCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjEiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiLz48L3N2Zz4=')]"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Main Footer Content */}
          <div className="grid md:grid-cols-4 gap-8 mb-12">
            
            {/* Brand Section */}
            <div className="md:col-span-2">
              <div className="mb-6">
                <h3 className="text-4xl font-black bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent mb-4">
                  WiredByApun
                </h3>
                <p className="text-gray-400 text-lg leading-relaxed max-w-md">
                  Design. Code. Swag. <br />
                  Apun banata hai brands jo dikhte hain ekdum next level! 🔥
                </p>
              </div>
              
              <div className="flex space-x-4">
                <Button 
                  size="sm" 
                  className="bg-green-600 hover:bg-green-700"
                  onClick={() => window.open(contactData.socialLinks.whatsapp, '_blank')}
                >
                  WhatsApp 📱
                </Button>
                <Button 
                  size="sm" 
                  variant="outline" 
                  className="border-purple-500 text-purple-400 hover:bg-purple-500 hover:text-white"
                  onClick={() => window.open(contactData.socialLinks.instagram, '_blank')}
                >
                  Instagram 📸
                </Button>
              </div>
            </div>

            {/* Services Links */}
            <div>
              <h4 className="text-xl font-bold mb-4 text-orange-400">Services</h4>
              <ul className="space-y-3">
                <li><a href="#services" className="text-gray-400 hover:text-white transition-colors duration-300">Logo Design</a></li>
                <li><a href="#services" className="text-gray-400 hover:text-white transition-colors duration-300">Website Development</a></li>
                <li><a href="#services" className="text-gray-400 hover:text-white transition-colors duration-300">PR Kits</a></li>
                <li><a href="#services" className="text-gray-400 hover:text-white transition-colors duration-300">Creative Videos</a></li>
                <li><a href="#services" className="text-gray-400 hover:text-white transition-colors duration-300">Complete Branding</a></li>
              </ul>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-xl font-bold mb-4 text-blue-400">Quick Links</h4>
              <ul className="space-y-3">
                <li><a href="#about" className="text-gray-400 hover:text-white transition-colors duration-300">About Apun</a></li>
                <li><a href="#portfolio" className="text-gray-400 hover:text-white transition-colors duration-300">Portfolio</a></li>
                <li><a href="#testimonials" className="text-gray-400 hover:text-white transition-colors duration-300">Testimonials</a></li>
                <li><a href="#contact" className="text-gray-400 hover:text-white transition-colors duration-300">Contact</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors duration-300">Pricing</a></li>
              </ul>
            </div>
          </div>

          {/* Contact Info Bar */}
          <div className="border-t border-gray-700 pt-8 mb-8">
            <div className="grid md:grid-cols-3 gap-6 text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start">
                <span className="text-2xl mr-3">📱</span>
                <div>
                  <div className="text-gray-400 text-sm">WhatsApp</div>
                  <div className="text-white font-semibold">{contactData.whatsapp}</div>
                </div>
              </div>
              
              <div className="flex items-center justify-center md:justify-start">
                <span className="text-2xl mr-3">📧</span>
                <div>
                  <div className="text-gray-400 text-sm">Email</div>
                  <div className="text-white font-semibold">{contactData.email}</div>
                </div>
              </div>
              
              <div className="flex items-center justify-center md:justify-start">
                <span className="text-2xl mr-3">📸</span>
                <div>
                  <div className="text-gray-400 text-sm">Instagram</div>
                  <div className="text-white font-semibold">{contactData.instagram}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Fun Stats */}
          <div className="bg-gradient-to-r from-blue-600/20 to-purple-600/20 backdrop-blur-sm rounded-2xl p-6 mb-8 border border-white/10">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
              <div>
                <div className="text-2xl font-black text-white">200+</div>
                <div className="text-gray-400 text-sm">Projects Done</div>
              </div>
              <div>
                <div className="text-2xl font-black text-white">99%</div>
                <div className="text-gray-400 text-sm">Happy Clients</div>
              </div>
              <div>
                <div className="text-2xl font-black text-white">24/7</div>
                <div className="text-gray-400 text-sm">Available</div>
              </div>
              <div>
                <div className="text-2xl font-black text-white">48hr</div>
                <div className="text-gray-400 text-sm">Avg Delivery</div>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-700 pt-8 text-center">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <div className="text-gray-400 mb-4 md:mb-0">
                © {currentYear} WiredByApun. Made with ❤️ in India
              </div>
              
              <div className="flex items-center space-x-6">
                <span className="text-gray-400 text-sm">Made by</span>
                <div className="text-white font-bold">Apun 🚀</div>
              </div>
            </div>
            
            <div className="mt-4 text-gray-500 text-sm">
              Design. Code. Swag. - Tu brand banwa... DM fast fast! 💬
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;